import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=ce915750&scoped=true&functional=true&"
import script from "./Notice.vue?vue&type=script&lang=ts&"
export * from "./Notice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "ce915750",
  null
  
)

export default component.exports